import '../styles/App.scss'
import '../styles/Preferences.scss'
import '../styles/SmsToggle.scss'

import {AppBarContainer} from './CustomAppBar'
import * as React from 'react'
import PageTitle from '../components/PageTitle'
import {LoadingSpinner} from '../components/LoadingSpinner'
import ConfirmationDialog from '../components/ConfirmationDialog'
import {FlatButton} from 'material-ui'
import {FieldValidatedValue, FormValidator} from '../utils/validation/FormValidator'
import * as classnames from 'classnames'
import {Validator} from '../utils/validation/Validator'
import * as Validators from '../utils/validation/Validators'
import {Strings} from '../localization'
import {StoreState} from '../reducers'
import {connect, Dispatch} from 'react-redux'
import {RouterAction} from 'react-router-redux'
import {Actions as SignInActions, ActionType as SignInActionType} from '../actions/signIn'
import {ClientInfo} from '../types'
import {isNullOrUndefined} from 'util'
import {Auth} from 'aws-amplify'
import {Api} from '../services/api/api'
import Stripe from '../services/stripe/stripe'
import Currencies from '../types/enums/Currencies'
import Countries from '../types/enums/Counties'

import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {Masker} from '../utils/masker/Masker'
import {StringResources} from '../localization/StringResources'

import {BaseContainer} from './BaseContainer'
import {EventType} from '../services/events/events'

import {AcceptDialog} from '../components/AcceptDialog'
import {Actions} from '../constants/components/AcceptDialog'
import {ClientType} from '../types/enums';

enum FormPersonalInfoFields {
  FirstName = 'firstNameInput',
  LastName = 'lastNameInput',
  Phone = 'phoneInput',
  Avatar = 'avatarInput'
}
enum FormPasswordFields {
  Password = 'passwordInput',
  NewPassword = 'newPasswordInput',
  NewPasswordConformation = 'newPasswordConformationInput'
}
enum FormPaymentInfoFields {
  CardNumber = 'cardNumberInput',
  CardExpirationDate = 'cardExpirationDateInput',
  CardCvv = 'cardCvvInput'
}

interface FormPersonalInfoType {
  [FormPersonalInfoFields.FirstName]: FieldValidatedValue
  [FormPersonalInfoFields.LastName]: FieldValidatedValue
  [FormPersonalInfoFields.Phone]: FieldValidatedValue
  [FormPersonalInfoFields.Avatar]: FieldValidatedValue
}
interface FormPasswordType {
  [FormPasswordFields.Password]: FieldValidatedValue
  [FormPasswordFields.NewPassword]: FieldValidatedValue
  [FormPasswordFields.NewPasswordConformation]: FieldValidatedValue
}
interface FormPaymentInfoType {
  [FormPaymentInfoFields.CardNumber]: FieldValidatedValue
  [FormPaymentInfoFields.CardExpirationDate]: FieldValidatedValue
  [FormPaymentInfoFields.CardCvv]: FieldValidatedValue
}

interface PreferencesProps {
  clientInfo: ClientInfo
  onUpdatePersonalInfo: (userData: ClientInfo) => SignInActionType
}

interface PreferencesState {
  inProcess: boolean
  AvatarUploadingInProcess: boolean

  formPersonalInfo: FormPersonalInfoType
  formPassword: FormPasswordType
  formPaymentInfo: FormPaymentInfoType
  fieldsPersonalInfoError: boolean
  fieldsPaymentInfoError: boolean
  fieldsPasswordError: boolean
  errorText?: string
  serverError: boolean
  error: boolean

  isSmsOptedIn: boolean
  isSmsDialogOpen: boolean
  action?: string
}

interface DialogState {
  isDialogOpen: boolean
  dialogTitle: string
  dialogContent: any
}

class Preferences extends React.Component<PreferencesProps, PreferencesState & DialogState> {
  private _stripe: Stripe

  private formPersonalInfoValidator: FormValidator<FormPersonalInfoType>
  private formPasswordValidator: FormValidator<FormPasswordType>
  private formPaymentInfoValidator: FormValidator<FormPaymentInfoType>

  constructor(props: any) {
    super(props)
    this.formPersonalInfoValidator = this.initPersonalInfoForm()
    this.formPasswordValidator = this.initPasswordForm()
    this.formPaymentInfoValidator = this.initPaymentInfoForm()
    this.state = {
      inProcess: false,
      AvatarUploadingInProcess: false,
      isDialogOpen: false,
      dialogTitle: '',
      dialogContent: '',

      formPersonalInfo: this.formPersonalInfoValidator.values(),
      formPassword: this.formPasswordValidator.values(),
      formPaymentInfo: this.formPaymentInfoValidator.values(),
      fieldsPersonalInfoError: false,
      fieldsPaymentInfoError: false,
      fieldsPasswordError: false,
      serverError: false,
      error: false,
      isSmsOptedIn: this.props.clientInfo.isSmsOptedIn,
      isSmsDialogOpen: false,
    }
  }
  get getFullName() {
    return `${this.state.formPersonalInfo[FormPersonalInfoFields.FirstName].value} ${this.state.formPersonalInfo[FormPersonalInfoFields.LastName].value}`
  }
  get CardExpMonth() {
    // tslint:disable-next-line:radix
    return parseInt((this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].value as string).substr(0, 2))
  }

  get CardExpYear() {
    // tslint:disable-next-line:radix
    return parseInt((this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].value as string).substr(2))
  }
  buildPhoneNumber = () => {
    let mobilePhone = '+1'
    let { length } = this.state.formPersonalInfo[FormPersonalInfoFields.Phone].value
    for (let i = 0; i < length; i++) {
      if (!isNaN(Number(this.state.formPersonalInfo[FormPersonalInfoFields.Phone].value[i]))) {
        mobilePhone += this.state.formPersonalInfo[FormPersonalInfoFields.Phone].value[i]
      }
    }
    return mobilePhone
  }
  trimPhoneNumber = (phone: string) => {
    return phone.substr(2)
  }
  componentDidMount() {
    if (this.props.clientInfo.isSmsOptedIn === undefined) {
      this.setState({
        isSmsDialogOpen: true,
        action: Actions.ACCEPT_SMS
      })
    }

    Stripe.getStripe()
      .then(stripe => {
        this._stripe = stripe
        console.log(stripe)
      })
      .catch(error => {
        console.log('resolving stripe obj error')
        console.log(error)
      })
    // this.updatePersonalInfoValueWithValidation(FormPersonalInfoFields.Avatar, this.props.clientInfo.avatar)
    this.updatePersonalInfoValueWithValidation(FormPersonalInfoFields.FirstName, this.props.clientInfo.firstName)
    this.updatePersonalInfoValueWithValidation(FormPersonalInfoFields.LastName, this.props.clientInfo.lastName)
    this.updatePersonalInfoValueWithValidation(FormPersonalInfoFields.Phone, this.trimPhoneNumber(this.props.clientInfo.phone))
    this.getAndSaveUserData()
  }

  getAndSaveUserData = () => {
    Api.getClientInfo()
      .then((userData: ClientInfo) => {
        console.log(userData)
        this.setState({
          isSmsOptedIn: userData.isSmsOptedIn
        })
        this.props.onUpdatePersonalInfo(userData)
      })
      .catch(error => {
        console.log(error)
      })
  }

  onDialogOkClick = () => {
    this.setState({ isDialogOpen: false })
  }
  /* https://gotrashyinc.atlassian.net/browse/GT2-1696 remove avatar uploading
  handleAvatarClick = () => {
    let fileUpload = ReactDOM.findDOMNode(this.refs['refAvatarInput']) as HTMLInputElement
    if (fileUpload != null) {
      fileUpload.click()
    }
  }
  handleFileUpload = async (event) => {
    let file = event.target.files[0]
    if (file != null) {
      let fileUrl = URL.createObjectURL(file)
      this.setState({ AvatarUploadingInProcess: true })

      try {
        let attachmentObj = await Api.getAvatarIdAuthorized(this.props.clientInfo.email)
        let uploadResponse = await Api.uploadImage(attachmentObj, fileUrl)
        this.updatePersonalInfoValueWithValidation(FormPersonalInfoFields.Avatar, fileUrl)
        this.setState({
          isDialogOpen: true,
          dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.Avatar),
          dialogContent: Strings.Preferences.Messages.Content.AvatarUploadSuccess
        })
        this.getAndSaveUserData()
      } catch (error) {
        console.log('avatar upload error', error)
        this.setState({ serverError: true })
        this.setState({
          isDialogOpen: true,
          dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.Avatar),
          dialogContent: StringResources.getString(Strings.Common.InternalError)
        })
      }
      this.setState({ AvatarUploadingInProcess: false })
    }
  }
  */
  updatePersonalInfoClick = async () => {
    await this.validatePersonalInfoFields()
    if (this.state.fieldsPersonalInfoError) {
      return
    }
    this.setState({ inProcess: true })
    try {
      let clientInfo = this.props.clientInfo
      clientInfo = {
        ...clientInfo,
        firstName: this.state.formPersonalInfo[FormPersonalInfoFields.FirstName].value,
        lastName: this.state.formPersonalInfo[FormPersonalInfoFields.LastName].value,
        phone: this.buildPhoneNumber()
      }
      let updateResponse = await Api.setClientInfo(clientInfo)
      this.setState({
        isDialogOpen: true,
        dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.PersonalInfo),
        dialogContent: StringResources.getString(Strings.Preferences.Messages.Content.PersonalInfoUpdateSuccess)
      })
      this.getAndSaveUserData()
    } catch (error) {
      console.log('personal info updating error', error)
      this.setState({
        isDialogOpen: true,
        dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.PersonalInfo),
        dialogContent: StringResources.getString(Strings.Common.InternalError)
      })
      this.setState({ serverError: true })
    }
    this.setState({ inProcess: false })
  }

  updatePasswordClick = async () => {
    await this.validatePasswordFields()
    if (this.state.fieldsPasswordError) {
      return
    }
    this.setState({ inProcess: true })
    Auth.currentAuthenticatedUser().then((user) => {
      Auth.changePassword(user, this.state.formPassword[FormPasswordFields.Password].value,
        this.state.formPassword[FormPasswordFields.NewPassword].value).then((changeResult) => {
          this.setState({
            isDialogOpen: true,
            dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.Password),
            dialogContent: StringResources.getString(Strings.Preferences.Messages.Content.PasswordUpdateSuccess)
          })
          for (const field in FormPasswordFields) {
            this.formPasswordValidator.setState([{
              name: FormPasswordFields[field],
              value: ''
            }], false, false)
          }
          this.setState({
            formPassword: this.formPasswordValidator.values(),
            fieldsPasswordError: !this.formPaymentInfoValidator.isValid()
          })
        }).catch((changeError) => {
          console.log('auth change password error', changeError)
          this.setState({
            isDialogOpen: true,
            dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.Password),
            dialogContent: StringResources.getString(Strings.Common.InternalError)
          })
          this.setState({ serverError: true })
        })
    })
    this.setState({ inProcess: false })
  }
  updateCardInfo = async () => {
    await this.validatePaymentInfoFields()
    if (this.state.fieldsPaymentInfoError) {
      return
    }
    this.setState({ inProcess: true })

    try {
      let stripeToken = await this._stripe.createToken({
        cardNumber: (this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].value),
        name: this.getFullName,
        cvc: this.state.formPaymentInfo[FormPaymentInfoFields.CardCvv].value as number,
        expireMonth: this.CardExpMonth,
        expireYear: this.CardExpYear,
        country: Countries.US,
        currency: Currencies.USD
      })
      console.log('stripe token creation success', stripeToken)
      let sendTokenResponse = await Api.sendStripeTokenAuthorized(stripeToken.id)
      console.log('updateCardInfo success', sendTokenResponse)
      for (const field in FormPaymentInfoFields) {
        this.formPaymentInfoValidator.setState([{
          name: FormPaymentInfoFields[field],
          value: ''
        }], false, false)
      }
      this.setState({
        formPaymentInfo: this.formPaymentInfoValidator.values(),
        fieldsPaymentInfoError: !this.formPaymentInfoValidator.isValid()
      })
      this.setState({
        isDialogOpen: true,
        dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.CardInfo),
        dialogContent: StringResources.getString(Strings.Preferences.Messages.Content.CardInfoUpdateSuccess)
      })
    } catch (error) {
      console.log('card info updating error', error)
      this.setState({ serverError: true })
      this.setState({
        isDialogOpen: true,
        dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.CardInfo),
        dialogContent: StringResources.getString(Strings.Common.InternalError)
      })
    }

    this.setState({ inProcess: false })
  }
  updatePersonalInfoValueWithValidation = (name: string, value: any) => {
    return new Promise(resolve => {
      this.formPersonalInfoValidator.setState([{
        name: name,
        value: value
      }])
      this.setState({
        formPersonalInfo: this.formPersonalInfoValidator.values(),
        fieldsPersonalInfoError: !this.formPersonalInfoValidator.isValid(),
        errorText: this.formPersonalInfoValidator.getError(),
        serverError: false,
        error: false
      }, () => { resolve() })
    })
  }

  updatePasswordValueWithValidation = (name: string, value: any) => {
    return new Promise(resolve => {
      this.formPasswordValidator.setState([{
        name: name,
        value: value
      }])
      this.setState({
        formPassword: this.formPasswordValidator.values(),
        fieldsPasswordError: !this.formPasswordValidator.isValid(),
        errorText: this.formPasswordValidator.getError(),
        serverError: false,
        error: false
      }, () => { resolve() })
    })
  }

  updatePaymentInfoValueWithValidation = (name: string, value: any) => {
    return new Promise(resolve => {
      this.formPaymentInfoValidator.setState([{
        name: name,
        value: value
      }])
      this.setState({
        formPaymentInfo: this.formPaymentInfoValidator.values(),
        fieldsPaymentInfoError: !this.formPaymentInfoValidator.isValid(),
        errorText: this.formPaymentInfoValidator.getError(),
        serverError: false,
        error: false
      }, () => { resolve() })
    })
  }
  onPersonalInfoChange = (e: (React.ChangeEvent<HTMLInputElement> & React.ChangeEvent<HTMLSelectElement>) | (React.FocusEvent<HTMLInputElement>)) => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    this.updatePersonalInfoValueWithValidation(e.target.name, value)
  }
  onPaymentInfoChange = (e: (React.ChangeEvent<HTMLInputElement> & React.ChangeEvent<HTMLSelectElement>) | (React.FocusEvent<HTMLInputElement>)) => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    this.updatePaymentInfoValueWithValidation(e.target.name, value)
  }
  onPasswordChange = (e: (React.ChangeEvent<HTMLInputElement> & React.ChangeEvent<HTMLSelectElement>) | (React.FocusEvent<HTMLInputElement>)) => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    this.updatePasswordValueWithValidation(e.target.name, value)
  }
  validatePersonalInfoFields = () => {
    return new Promise((resolve) => {
      this.formPersonalInfoValidator.validate()
      this.setState({
        formPersonalInfo: this.formPersonalInfoValidator.values(),
        fieldsPersonalInfoError: !this.formPersonalInfoValidator.isValid(),
        errorText: this.formPersonalInfoValidator.getError(),
        serverError: false,
        error: false
      }, () => { resolve() })
    })
  }

  validatePasswordFields = () => {
    return new Promise((resolve) => {
      this.formPasswordValidator.validate()
      this.setState({
        formPassword: this.formPasswordValidator.values(),
        fieldsPasswordError: !this.formPasswordValidator.isValid(),
        errorText: this.formPasswordValidator.getError(),
        serverError: false,
        error: false
      }, () => { resolve() })
    })
  }

  validatePaymentInfoFields = () => {
    return new Promise((resolve) => {
      this.formPaymentInfoValidator.validate()
      this.setState({
        formPaymentInfo: this.formPaymentInfoValidator.values(),
        fieldsPaymentInfoError: !this.formPaymentInfoValidator.isValid(),
        errorText: this.formPaymentInfoValidator.getError(),
        serverError: false,
        error: false
      }, () => { resolve() })
    })
  }

  smsCheckboxChange = (event, value?: boolean) => {
    this.setState({ inProcess: true })
    let clientInfo = this.props.clientInfo
    clientInfo = {
      ...clientInfo,
      isSmsOptedIn: value !== undefined ? value : !this.state.isSmsOptedIn
    }

    let isSmsOptedIn = value !== undefined ? value : !this.state.isSmsOptedIn

    Api.sendOptIn(isSmsOptedIn, true)
      .then(() => {
        this.setState({
          isSmsOptedIn: clientInfo.isSmsOptedIn,
          inProcess: false,
          isDialogOpen: true,
          dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.SMS),
          dialogContent: StringResources.getString(Strings.Preferences.Messages.Content.SmsSuccess)
        })
      })
      .catch(error => {
        console.log('personal info updating error', error)
        this.setState({
          serverError: true,
          inProcess: false,
          isDialogOpen: true,
          dialogTitle: StringResources.getString(Strings.Preferences.Messages.Titles.SMS),
          dialogContent: StringResources.getString(Strings.Common.InternalError)
        })
      })
  }

  handleSmsDialogClose = () => {
    this.setState({
      isSmsDialogOpen: false
    })
  }

  acceptSmsNotifications = (event) => {
    this.handleSmsDialogClose()
    this.smsCheckboxChange(event, true)
  }

  declineSmsNotifications = (event) => {
    this.handleSmsDialogClose()
    this.smsCheckboxChange(event, false)
  }

  render() {
    return (
      <BaseContainer pageName={EventType.PREFERENCES} >
        <LoadingSpinner show={this.state.inProcess} />
        <ConfirmationDialog
          isDialogOpen={this.state.isDialogOpen}
          OkButtonText="Ok"
          disableBackDropClick={true}
          disableEscapeKeyDown={true}
          onOkButtonClick={this.onDialogOkClick}
          title={this.state.dialogTitle}
          content={this.state.dialogContent}
        />
        <AppBarContainer
          isIconButtonsShown={true}
          isMenuShown={true}
        />
        <AcceptDialog
          isAcceptDialogOpen={this.state.isSmsDialogOpen}
          handleDialogClose={this.handleSmsDialogClose}
          action={this.state.action}
          acceptSmsNotifications={this.acceptSmsNotifications}
          declineSmsNotifications={this.declineSmsNotifications}
        />
        <PageTitle text={StringResources.getString(Strings.Preferences.Title)} />
        <PerfectScrollbar className="preferences-scrollbar">
          <div className={classnames('alertMessage', { active: this.state.error })}>{StringResources.getString(Strings.Common.Error)}!
            {this.state.errorText}
          </div>
          <div className={classnames('alertMessage', { active: this.state.serverError })}>{StringResources.getString(Strings.Common.InternalError)}</div>
          <div
            className={classnames('alertMessage', {
              active: (this.state.fieldsPersonalInfoError || this.state.fieldsPaymentInfoError ||
                this.state.fieldsPasswordError) && !isNullOrUndefined(this.state.errorText)
            })}
          >
            {`${StringResources.getString(Strings.Common.Error)}! ${this.state.errorText}`}
          </div>
          <div className="title">{StringResources.getString(Strings.Preferences.PersonalInfo.Title)}</div>
          {/*TODO: Make generic avatar uploader component*/}
          {
            // <div className="avatar">
            // {
            /*
            this.state.formPersonalInfo[FormPersonalInfoFields.Avatar].value ?
              <Avatar
                className="preferences-avatar"
                src={this.state.formPersonalInfo[FormPersonalInfoFields.Avatar].value}
                onClick={this.handleAvatarClick}
              /> :
              <Avatar
                className="preferences-avatar"
                onClick={this.handleAvatarClick}
              >
                {StringResources.getString(Strings.Preferences.PersonalInfo.Inputs.Avatar.placeholder)}
              </Avatar>
              */
            // }
            //  <LoadingSpinner
            //  show={this.state.AvatarUploadingInProcess}
            // classes="shadowForImg avatar-loader"
            /// >
            // </div>
          }
          {/*
          <span
            className="avatar-fullname"
          >
            {`${this.state.formPersonalInfo[FormPersonalInfoFields.FirstName].value} ${this.state.formPersonalInfo[FormPersonalInfoFields.LastName].value}`}
          </span>*/
          }
          <form className="update-personal-info-form">
            {/*
            <input
              // tslint:disable-next-line:jsx-no-string-ref
              ref="refAvatarInput"
              name={FormPersonalInfoFields.Avatar}
              className={classnames({ error: this.state.formPersonalInfo[FormPersonalInfoFields.Avatar].error })}
              type="file"
              accept="image/*"
              onChange={this.handleFileUpload}
            />*/
            }
            <input
              type="text"
              name={FormPersonalInfoFields.FirstName}
              className={classnames('half-sized','left-input', { error: this.state.formPersonalInfo[FormPersonalInfoFields.FirstName].error })}
              placeholder={StringResources.getString(Strings.Preferences.PersonalInfo.Inputs.FirstName.placeholder)}
              value={this.state.formPersonalInfo[FormPersonalInfoFields.FirstName].value}
              onChange={this.onPersonalInfoChange}
            />
            <input
              type="text"
              name={FormPersonalInfoFields.LastName}
              className={classnames('half-sized', { error: this.state.formPersonalInfo[FormPersonalInfoFields.LastName].error })}
              placeholder={StringResources.getString(Strings.Preferences.PersonalInfo.Inputs.LastName.placeholder)}
              value={this.state.formPersonalInfo[FormPersonalInfoFields.LastName].value}
              onChange={this.onPersonalInfoChange}
            />
            <input
              type="text"
              placeholder={StringResources.getString(Strings.Preferences.PersonalInfo.Inputs.Phone.placeholder)}
              name={FormPersonalInfoFields.Phone}
              className={classnames('full-sized', { error: this.state.formPersonalInfo[FormPersonalInfoFields.Phone].error })}
              value={this.state.formPersonalInfo[FormPersonalInfoFields.Phone].masked ?
                this.state.formPersonalInfo[FormPersonalInfoFields.Phone].masked : ''}
              onChange={this.onPersonalInfoChange}
            />
            <input
              type="email"
              className="full-sized"
              disabled={true}
              value={this.props.clientInfo.email}
            />
          </form>
          <div className="bottom-part hover">
            <FlatButton
              label={StringResources.getString(Strings.Preferences.PersonalInfo.Buttons.UpdatePersonalInfo.label)}
              className="flatbutton"
              onClick={this.updatePersonalInfoClick}
            />
          </div>

          {
            this.state.isSmsOptedIn !== undefined ?
              <div>
                <div className="title">{StringResources.getString(Strings.Preferences.Notifications.Title)}</div>
                <form className="sms-form">
                  <div id="sms-toggle">
                    <input
                      type="checkbox"
                      name="sms-checkbox1"
                      id="sms-checkbox"
                      className="ios-toggle"
                      checked={this.state.isSmsOptedIn}
                      onChange={this.smsCheckboxChange}
                    />
                    <label htmlFor="sms-checkbox" className="sms-checkbox-label" data-off="off" data-on="on" />
                  </div>
                  <p className="sms-p">{StringResources.getString(Strings.Preferences.Notifications.Inputs.Checkbox)}</p>
                </form>
              </div>
              : null
          }

          <div className="title">{StringResources.getString(Strings.Preferences.Password.Title)}</div>
          <form className="update-password-form">
            <input
              type="password"
              name={FormPasswordFields.Password}
              className={classnames('full-sized', { error: this.state.formPassword[FormPasswordFields.Password].error })}
              value={this.state.formPassword[FormPasswordFields.Password].value}
              placeholder={StringResources.getString(Strings.Preferences.Password.Inputs.Password.placeholder)}
              onChange={this.onPasswordChange}
            />
            <input
              type="password"
              name={FormPasswordFields.NewPassword}
              className={classnames('full-sized', { error: this.state.formPassword[FormPasswordFields.NewPassword].error })}
              value={this.state.formPassword[FormPasswordFields.NewPassword].value}
              placeholder={StringResources.getString(Strings.Preferences.Password.Inputs.NewPassword.placeholder)}
              onChange={this.onPasswordChange}
            />
            <input
              type="password"
              name={FormPasswordFields.NewPasswordConformation}
              className={classnames('full-sized', { error: this.state.formPassword[FormPasswordFields.NewPasswordConformation].error })}
              placeholder={StringResources.getString(Strings.Preferences.Password.Inputs.NewPasswordConfirm.placeholder)}
              value={this.state.formPassword[FormPasswordFields.NewPasswordConformation].value}
              onChange={this.onPasswordChange}
            />
          </form>
          <div className="bottom-part hover">
            <FlatButton
              label={StringResources.getString(Strings.Preferences.Password.Buttons.UpdatePassword.label)}
              className="flatbutton"
              onClick={this.updatePasswordClick}
            />
          </div>

          {
            this.props.clientInfo.type !== ClientType.COMMERCIAL &&
            <div>
              <div className="title">{StringResources.getString(Strings.Preferences.CardInfo.Title)}</div>
              <form className="update-card-info-form">
                <input
                    className={classnames('card-number', {error: this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].error})}
                    type="text"
                    name={FormPaymentInfoFields.CardNumber}
                    placeholder={StringResources.getString(Strings.Preferences.CardInfo.Inputs.CardNumber.placeholder)}
                    value={this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].masked ?
                        this.state.formPaymentInfo[FormPaymentInfoFields.CardNumber].masked : ''}
                    onChange={this.onPaymentInfoChange}
                    maxLength={19}
                />
                <input
                    className={classnames('expiration-date half-sized', {error: this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].error})}
                    type="text"
                    name={FormPaymentInfoFields.CardExpirationDate}
                    value={this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].masked ?
                        this.state.formPaymentInfo[FormPaymentInfoFields.CardExpirationDate].masked : ''}
                    onChange={this.onPaymentInfoChange}
                    placeholder={StringResources.getString(Strings.Preferences.CardInfo.Inputs.CardExpirationDate.placeholder)}
                    maxLength={5}
                />
                <input
                    name={FormPaymentInfoFields.CardCvv}
                    className={classnames('cvv', {error: this.state.formPaymentInfo[FormPaymentInfoFields.CardCvv].error})}
                    type="text"
                    placeholder={StringResources.getString(Strings.Preferences.CardInfo.Inputs.CardCVV.placeholder)}
                    value={this.state.formPaymentInfo[FormPaymentInfoFields.CardCvv].value}
                    onChange={this.onPaymentInfoChange}
                    required={true}
                    maxLength={4}
                />
              </form>
              <div className="bottom-part hover">
                <FlatButton
                    label={StringResources.getString(Strings.Preferences.CardInfo.Buttons.UpdateCardInfo.label)}
                    className="flatbutton"
                    onClick={this.updateCardInfo}
                />
              </div>
            </div>
          }
        </PerfectScrollbar>
      </BaseContainer>
    )
  }
  private initPaymentInfoForm = () => {
    let formValidator = new FormValidator<FormPaymentInfoType>([
      {
        name: FormPaymentInfoFields.CardNumber,
        value: '',
        validator: (value: any) => {
          return ((!this._stripe || !this._stripe.validateCardNumber(value))) ?
            'cardNumber' :
            undefined
        },
        messages: {
          cardNumber: StringResources.getString(Strings.Preferences.CardInfo.Errors.CardNumber)
        },
        masker: new Masker(Masker.cardNumber, Masker.placeSymbol),
        passMaskedToValidation: true
      },
      {
        name: FormPaymentInfoFields.CardExpirationDate,
        value: '',
        validator: (value: any) => {
          return ((!this._stripe || !this._stripe.validateExpireDateStr(value))) ?
            'expire' :
            undefined
        },
        messages: {
          expire: StringResources.getString(Strings.Preferences.CardInfo.Errors.ExpirationDate)
        },
        masker: new Masker(Masker.expireDateMask, Masker.placeSymbol),
        passMaskedToValidation: true
      },
      {
        name: FormPaymentInfoFields.CardCvv,
        value: '',
        validator: (value: any) => {
          return ((!this._stripe || !this._stripe.validateCvc(value))) ?
            'cvv' :
            undefined
        },
        messages: {
          cvv: StringResources.getString(Strings.Preferences.CardInfo.Errors.CVV)
        }
      }
    ])
    return formValidator
  }

  private initPasswordForm = () => {
    const passwordConfirm: Validator = (value: any) => {
      return !value ? 'passConfirm' : (value === this.state.formPassword[FormPasswordFields.NewPassword].value ? undefined : 'passConfirm')
    }
    let formValidator = new FormValidator<FormPasswordType>([
      {
        name: FormPasswordFields.Password,
        value: '',
        validator: Validators.password,
        messages: {
          pass: StringResources.getString(Strings.Preferences.Password.Errors.Password)
        }
      },
      {
        name: FormPasswordFields.NewPassword,
        value: '',
        validator: Validators.password,
        messages: {
          passConfirm: StringResources.getString(Strings.Preferences.Password.Errors.Password)
        }
      },
      {
        name: FormPasswordFields.NewPasswordConformation,
        value: '',
        validator: passwordConfirm,
        messages: {
          passConfirm: StringResources.getString(Strings.Preferences.Password.Errors.ConfirmPassword)
        }
      }
    ])
    return formValidator
  }

  private initPersonalInfoForm = () => {
    let formValidator = new FormValidator<FormPersonalInfoType>([
      /*
      {
        name: FormPersonalInfoFields.Avatar,
        value: '',
        validator: Validators.empty,
        messages: {
          empty: StringResources.getString(Strings.Preferences.PersonalInfo.Errors.Avatar)
      }
      },*/
      {
        name: FormPersonalInfoFields.FirstName,
        value: '',
        validator: Validators.name,
        messages: {
          name: StringResources.getString(Strings.Preferences.PersonalInfo.Errors.FirstName)
        }
      },
      {
        name: FormPersonalInfoFields.LastName,
        value: '',
        validator: Validators.name,
        messages: {
          name: StringResources.getString(Strings.Preferences.PersonalInfo.Errors.LastName)
        }
      },
      {
        name: FormPersonalInfoFields.Phone,
        value: '',
        validator: Validators.phone,
        messages: {
          phone: StringResources.getString(Strings.Preferences.PersonalInfo.Errors.Phone)
        },
        masker: new Masker(Masker.numberMask, Masker.placeSymbol)
      }
    ])
    return formValidator
  }
}
function mapStateToProps(state: StoreState) {
  return {
    clientInfo: state.auth.user
  }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction | SignInActionType>) {
  return {
    onUpdatePersonalInfo: (userData: ClientInfo) => dispatch(SignInActions.authorize(userData))
  }
}

export const PreferencesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Preferences)



// WEBPACK FOOTER //
// ./src/containers/PreferencesContainer.tsx